// @flow
import React from 'react';
import SMFormFieldBaseView from 'components/dashboard/form/SMFormFieldBaseView';
import SMFormRadio from 'components/dashboard/form/SMFormRadio';
import SMFormValidationMessage from 'components/dashboard/form/SMFormValidationMessage';

type Props = {
  items: Array<any>,
  delegate: Object,
  name: string,
  value: string,
  selectedValue: string,
  options: Array<any>,
};

type State = {
  name: string,
  value: string,
};

class SMFormRadioWithError extends SMFormFieldBaseView {
  state: State

  constructor(props: Props) {
    super(props);
    this.state = {
      name: this.props.name,
      value : this.props.value,
    };
  }

  componentWillReceiveProps(nextProps: Props) {
    this.setState({
      name: nextProps.name,
      value : nextProps.value,
    });
  }

  render() {
    return (
      <div className="form-box">
        <SMFormRadio
          items={this.props.items}
          delegate={this.props.delegate}
          name={this.state.name}
          value={this.state.value}
          selectedValue={this.props.selectedValue}
          options={this.props.options}
        />
        <SMFormValidationMessage name={this.props.name} errorText={this.props.errorText} />
      </div>
    );
  }
}
export default SMFormRadioWithError;


// WEBPACK FOOTER //
// ./app/javascript/components/dashboard/form/SMFormRadioWithError.jsx